module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAoCAMAAABevo0zAAAAQlBMVEX/AAD/R0f/Y2P/29v/6Oj/Cgr/VFT/////Gxv/cnL/h4f/lZX/7+//srL/oKD/XFz/zs7/ycn/NTX/eXn/+Pj/u7s/V1YHAAABDUlEQVRIx+WWy3LDIAxFL0/xsgHb+f9f7aLO0KR2xgEt0qlWwNWcAWkkBBwYXTRctT8JVIoZmDMvUAGKFZiBzAXUmkgBgPpeDwOT8ckCQE4eiePJrgmOJYa2CZYFGJoQWIBTE27DwBqIdBMSUai9QB8LkUX8kRVHFGGJSvQdQAmYBcBM4n4uaAawGEB2AG/33dyA8TGYb8bQnDuYrqTIcwf5CUDlXnk49f4Np1cxnHqeXE7v6EpfpejlWF50b+lt9ki120Ath99iGOs2z6nZ0zHQvvyj5If74VOq3Siwwgk/121dtzp74VAGgXr/52Lc/0DNNIqEwDzbrCsz0HtmoJTMQGuZgUL8uxn7MvAL2t0iyxNQ808AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/ca.png
// module id = 18o+
// module chunks = 2